function Footer() {
    return <footer>
        <img src="./img/cool-logo.gif" alt="cool vibes"/>
        <p>Site developed by hand in HTML5, CSS3, Sass, React, and jQuery. Background image is free-to-use from <a href="https://www.pexels.com/">Pexels.</a></p>
    </footer>
}

export default Footer;